var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mk-image-group-container"},[_c('img',{attrs:{"src":_vm.childItem.propsValue.data[0].customField1,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }